<template>
  <settings-modal class="t-ob-payment-view-modal">
    <span
      slot="heading"
      class="font-weight-bold"
    >View payment</span>

    <v-tabs
      v-model="tab"
      color="transparent"
      slider-color="red darken-2"
    >
      <v-tab key="payment">Payment</v-tab>
      <v-tab key="activity">Activity</v-tab>
      <v-tabs-items class="tab-items-container">
        <v-tab-item
          key="payment"
          :transition="false"
          :reverse-transition="false"
        >
          <open-banking-payment-details
            :payment="payment"
            class="pt-2"
          />
        </v-tab-item>
        <v-tab-item
          key="activity"
          :transition="false"
          :reverse-transition="false"
        >
          <open-banking-payment-activity :payment-id="payment.id" />
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>

    <template slot="actions">
      <v-btn
        class="t-cancel-button"
        color="primary"
        medium
        flat
        @click="onCloseButtonClick"
      >close</v-btn>
    </template>
  </settings-modal>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'

  import modal from '@/mixins/modal'
  import SettingsModal from '@/components/modals/SettingsModal'
  import OpenBankingPaymentDetails from '@/components/open-banking/OpenBankingPaymentDetails'
  import OpenBankingPaymentActivity from '@/components/open-banking/OpenBankingPaymentActivity'

  export default {
    name: 'OpenBankingPaymentModal',
    components: {
      SettingsModal,
      OpenBankingPaymentDetails,
      OpenBankingPaymentActivity
    },
    mixins: [modal],
    data () {
      return {
        tab: 'payment'
      }
    },
    computed: {
      ...mapGetters('modal', ['modal']),
      payment () {
        return this.modal.data.payment
      }
    },
    methods: {
      ...mapActions('modal', ['closeModal']),
      onCloseButtonClick () {
        this.closeModal()
      }
    }
  }
</script>

<style lang="scss">
  .tab-items-container {
    margin-top: -2px;
    border-top: 2px solid rgba(#000, 0.12);
  }
</style>
